<div class="progress loop" [class.visible]="loading$ | async"></div>
<router-outlet></router-outlet>
<vdr-overlay-host></vdr-overlay-host>
